/**
 * Copyright (c) 2017 CA. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */

export default () => ({
  chart: {
    width: '95%',
  },
});



// WEBPACK FOOTER //
// ./src/pages/Dashboard/CompositeXYChart/styles.js